import { RouteObject } from "react-router-dom";
import AssetDetail from "./components/Details/DetailsLanding";
import Landing from "./components/Landing";
import AddAsset from "./components/create/create";

export interface assetsRoutes extends Omit<RouteObject, "children"> {
  auth?: boolean;
  children?: assetsRoutes[];
}

export const assetsRoutes: assetsRoutes[] = [
  {
    path: "/ax/asset-registry/assets",
    element: <Landing />,
  },
  {
    path: "/ax/asset-registry/assets/create/:action",
    element: <AddAsset />,
  },
  {
    path: "/ax/asset-registry/assets/create/:action/:id",
    element: <AddAsset />,
  },
  {
    path: "/ax/asset-registry/assets/view/:id",
    element: <AssetDetail />,
  },
  {
    path: "/ax/asset-registry/assets/view/:id/:energyAsset",
    element: <AssetDetail />,
  },
];
